function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F44336"
    },
    d: "M295.776,175.708h-79.584c-32.96,0-82.528-27.872-100.832-46.304 C89.6,103.452,89.6,61.18,115.392,35.228c25.056-25.216,68.768-25.216,93.856,0c13.856,13.952,50.656,70.624,45.6,108.448h2.272 c-5.056-37.824,31.744-94.496,45.632-108.448c25.024-25.216,68.736-25.28,93.856,0c25.824,25.952,25.824,68.192,0,94.144 C378.304,147.804,328.736,175.708,295.776,175.708z M295.776,143.708c22.112,0,64.352-22.976,78.112-36.864 c13.44-13.504,13.44-35.52,0-49.024c-12.992-13.088-35.552-13.024-48.48,0c-21.568,21.696-43.008,77.12-35.552,84.832 C289.888,142.652,291.232,143.708,295.776,143.708z M162.336,47.708c-9.152,0-17.76,3.584-24.256,10.112 c-13.408,13.504-13.408,35.52,0,49.024c13.792,13.888,56,36.864,78.112,36.864c4.576,0,5.92-1.024,5.92-1.024 c7.456-7.776-13.984-63.2-35.552-84.864C180.064,51.292,171.456,47.708,162.336,47.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M32,239.708v224c0,17.664,14.368,32,32,32h384c17.664,0,32-14.336,32-32v-224H32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD54F"
    },
    d: "M480,143.708H32c-17.632,0-32,14.368-32,32v80c0,8.832,7.168,16,16,16h480c8.832,0,16-7.168,16-16 v-80C512,158.044,497.664,143.708,480,143.708z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 143.708,
    style: {
      fill: "#F44336"
    },
    width: 64,
    height: 352
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift.a18fe87e.svg";
export { ForwardRef as ReactComponent };